import * as React from "react";
import { ACountry } from "../../Common";

import { MyBagPresentationShippingDetailsOnCart } from "../model";
import { useMyBagPresentationModel } from "../providers";

export const FragmentDeliveryAddress: React.FunctionComponent<{
  shippingDetails?: MyBagPresentationShippingDetailsOnCart;
}> = ({ shippingDetails }) => {
  const { presentationMyBagShippingDetailsOnCart } =
    useMyBagPresentationModel();
  const deliveryDetails =
    shippingDetails || presentationMyBagShippingDetailsOnCart;

  const presentablePhoneLabel = React.useMemo(() => {
    const numberNoFormatting = deliveryDetails?.phone;
    if (!numberNoFormatting) {
      return "";
    } else if (numberNoFormatting.startsWith("+61")) {
      return `${numberNoFormatting.substring(
        0,
        3
      )} ${numberNoFormatting.substring(3, 6)} ${numberNoFormatting.substring(
        6,
        9
      )} ${numberNoFormatting.substring(9)}`;
    } else if (numberNoFormatting.startsWith("61")) {
      return `${numberNoFormatting.substring(
        0,
        2
      )} ${numberNoFormatting.substring(2, 5)} ${numberNoFormatting.substring(
        5,
        8
      )} ${numberNoFormatting.substring(8)}`;
    } else if (numberNoFormatting.startsWith("0")) {
      return `${numberNoFormatting.substring(
        0,
        4
      )} ${numberNoFormatting.substring(4, 7)} ${numberNoFormatting.substring(
        7
      )}`;
    } else {
      return `${numberNoFormatting.substring(
        0,
        3
      )} ${numberNoFormatting.substring(3, 6)} ${numberNoFormatting.substring(
        7
      )}`;
    }
  }, [deliveryDetails?.phone]);

  if (!deliveryDetails) {
    return null;
  }
  return (
    <React.Fragment>
      <p className="full-name">
        <span className="first-name">{`${deliveryDetails.firstName}`}</span>
        <span className="only-a-space">&nbsp;</span>
        <span className="last-name">{`${deliveryDetails.lastName}`}</span>
      </p>

      <p className="address-line-1">
        {`${deliveryDetails.addressLine1}`}
      </p>
      {deliveryDetails.addressLine2 && (
        <p className="address-line-2">
          {`${deliveryDetails.addressLine2}`}
        </p>
      )}

      <p className="city-state-postcode">
        <span className="city">{`${deliveryDetails.city}`}</span>
        <span className="only-a-space">&nbsp;</span>
        {deliveryDetails.stateLabel && (
          <React.Fragment>
            <span className="state">{`${deliveryDetails.stateLabel}`}</span>
            <span className="only-a-space">&nbsp;</span>
          </React.Fragment>
        )}
        <span className="postcode">{`${deliveryDetails.postcode}`}</span>
      </p>

      <p className="country">
        {`${
          ([
            [ACountry.Australia.toUpperCase(), "Australia"],
            [ACountry.NewZealand.toUpperCase(), "New Zealand"],
          ].find(
            ([code, label]) =>
              code === deliveryDetails.country
          ) || [ACountry.Australia.toUpperCase(), "Australia"])[1]
        }`}
      </p>

      <p className="phone">{`${presentablePhoneLabel}`}</p>

      <p className="email">
        <span className="preamble">{`The order confirmation will be sent to: `}</span>
        <span className="value">{`${deliveryDetails.email}`}</span>
      </p>
    </React.Fragment>
  );
};
